import React from 'react';
import PropTypes from 'prop-types';

import { dictionaryType } from 'types';
import SelectableList from 'components/SelectableList';
import DictionaryItem from './components/DictionaryItem';

const DictionariesList = props => {
  const {
    dictionaries,
    selectedDictionary,
    currentDictionaryIndex,
    selectDictionary,
    deselectDictionary,
  } = props;
  return (
    <SelectableList
      items={dictionaries}
      ItemComponent={<DictionaryItem />}
      selectedItem={selectedDictionary}
      currentItemIndex={currentDictionaryIndex}
      selectItem={selectDictionary}
      deselectItem={deselectDictionary}
    />
  );
};

DictionariesList.propTypes = {
  dictionaries: PropTypes.arrayOf(dictionaryType),
  selectedDictionary: dictionaryType,
  currentDictionaryIndex: PropTypes.number,
  selectDictionary: PropTypes.func,
  deselectDictionary: PropTypes.func,
};

export default DictionariesList;
